import { configureStore } from '@reduxjs/toolkit'
import userSettings from './features/userSettings'
import userReducer from './features/userSlice'

export const store = configureStore({
  reducer: {
    user: userReducer,
    settings: userSettings,
  },
})